import { BaseModel, Image } from '../../../shared/base/base.models';

export class Badge extends BaseModel {
    mnemonic?: string;
    name?: string;
    searchable?: boolean;
    image?: Image;
}
